/**
 * If a backend user visits the tradein app with "preview=true" as parameter. Then we make sure that all calls (using isPreview())
 * will return true until the preview context has timed out (24 hours).
 */

export const isPreview = () => {
   let dateTs = localStorage.getItem('preview');
   if(dateTs && dateTs==='true') {
      // legacy
      return true;
   } else {
      if(!dateTs) {
         return false;
      }
      try {
         const date = new Date(dateTs);
         let itemAge = Date.now() - date.getTime();
         return itemAge < (1000 * 60 * 60 * 24 * 7); // 1 week
      } catch (e) {
         return false;
      }
   }
}

export const setPreview = (preview: boolean) => {
   let dateTs = localStorage.getItem('preview');
   if(dateTs && dateTs==='true') {
      localStorage.removeItem("preview")
   }
      // If we receive preview=true then we set a preview
   if(preview) {
      let date = new Date();
      localStorage.setItem('preview', date.toString());
   }
}

